// src/components/NotificationModal.js
import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Loader from "../Loader/Loader";
import useApi from "../../hook/useApi";
import { toast } from "react-toastify";

const defaultNotification = {
  title: "",
  description: "",
};

const NotificationModal = ({
  show,
  handleClose,
  mode = "create",
  data = {},
}) => {
  const isView = mode === "view";
  const isCreate = mode === "create";

  const [formData, setFormData] = useState(defaultNotification);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { AsyncPostApiCall, AsyncPatchAPICall } = useApi();

  //  useEffect(() => {
  //   if (isCreate) {
  //     setFormData(defaultNotification);
  //   } else if (isView && data) {
  //     setFormData({
  //       title: data.title || "",
  //       body: data.body || "",
  //     });
  //   }
  // }, [mode, data]);

  const validate = () => {
    const newErrors = {};
    const trimmedTitle = formData.title.trim();
    const trimmedDescription = formData.description.trim();
    const validationRegex = /^[a-zA-Z][a-zA-Z0-9\s.,!?;:-]*$/;

    if (!trimmedTitle) {
      newErrors.title = "Title is required";
    }
    else if (trimmedTitle.length > 50) {
      newErrors.title = "Title cannot exceed 50 characters";
    }
    else {
      // Regex: Must start with a letter (after trimming leading/trailing spaces),
      // then allow letters, numbers, spaces, dots, and common punctuation/specials
      if (!validationRegex.test(trimmedTitle)) {
        newErrors.title = "Title must start with a letter and can only include letters, numbers, spaces, dots, and common punctuation (e.g., ., !, ?, ;, :, -)";
      }
    }

    if (!trimmedDescription) {
      newErrors.description = "Description is required";
    }
    else if (trimmedDescription.length > 200) {
      newErrors.description = "Description cannot exceed 200 characters";
    }
    else {
      // Same regex for description (adjust if you want more leniency, e.g., allow more specials)
      if (!validationRegex.test(trimmedDescription)) {
        newErrors.description = "Description must start with a letter and can only include letters, numbers, spaces, dots, and common punctuation (e.g., ., !, ?, ;, :, -)";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.trim()
    const newErrors = {};
    setFormData((prev) => ({
      ...prev,
      // [name]: trimmedValue,
      [name]: value,
    }));

    const upperCasedValue = name.charAt(0).toUpperCase() + name.slice(1)
    const validationRegex = /^[a-zA-Z][a-zA-Z0-9\s.,!?;:-]*$/;
    if (!trimmedValue) {
      newErrors[name] = `${upperCasedValue} is required`;
    } else if (name === "title" && value.length > 50) {
      newErrors[name] = "Title cannot exceed 50 characters";
    } else if (name === "description" && value.length > 200) {
      newErrors[name] = "Description cannot exceed 200 characters";
    }
    else if (!validationRegex.test(trimmedValue)) {
      newErrors[name] = `${upperCasedValue} must start with a letter and can only include letters, numbers, spaces, dots, and common punctuation (e.g., ., !, ?, ;, :, -)`;
    }

    console.log("errors", newErrors)
    setErrors((prev) => ({ ...prev, [name]: newErrors[name] }));
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);

    let endpoint = "";
    let apiCall = null;

    if (isCreate) {
      endpoint = "/notifications/admin/";
      apiCall = AsyncPostApiCall;
    }

    const payload = {
      ...formData,
      isAdmin: true,
    };

    const result = await apiCall(endpoint, payload);

    if (result?.errors) {
      toast.error(result.errors[0]);
    } else if (result?.success) {
      toast.success(
        `${result?.message || "Notifications successfully created for all users."
        }`
      );

      //Reset form fields after success
      setFormData(defaultNotification);
      handleClose(true); // trigger refetch
    }

    setLoading(false);
  };

  return (
    <>
      {loading && <Loader />}
      <Modal
        show={show}
        onHide={() => {
          handleClose();
          setFormData(defaultNotification);
          setErrors({});
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isCreate && "Notification for all users"}
            {isView && "View Notification"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            {/* Title */}
            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={formData?.title}
                onChange={handleChange}
                readOnly={isView}
                className={errors.title ? "is-invalid" : ""}
                placeholder="Enter Title"
                maxLength={50}
              />
              {errors.title && (
                <div className="invalid-feedback">{errors.title}</div>
              )}
            </Form.Group>

            {/* Body */}
            <Form.Group className="mb-3">
              <Form.Label>Body</Form.Label>
              <Form.Control
                as="textarea"
                name="description"
                rows={4}
                value={formData?.description}
                onChange={handleChange}
                readOnly={isView}
                className={errors.description ? "is-invalid" : ""}
                placeholder="Enter Text"
              />
              {errors.description && (
                <div className="invalid-feedback">{errors.description}</div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
              setFormData(defaultNotification);
            }}
          >
            Close
          </Button>
          {!isView && (
            <Button variant="primary" onClick={handleSubmit} disabled={loading}>
              {loading ? "Saving..." : "Create"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NotificationModal;
